import React, { useEffect, useRef, useState } from "react";
import "./PersonalDetails.css";
import backBtn from "../../../../assets/images/back-btn.svg";
import tickIcon from "../../../../assets/images/tick-icon.png";
import puzzleBg from "../../../../assets/images/puzzle-bg.svg";
import pendingIcon from "../../../../assets/images/pending-icon.svg";
import { useLocation, useNavigate } from "react-router-dom";
import { getTranslatedTextSelector } from "../../../../redux/slices/translatedText/getTranslatedText";
import { useSelector } from "react-redux";
import Loader from "../../../../utils/loader/Loader";
import { decrypt } from "../../../encryption/Encryption";
import { getScreeningProfilerHistory } from "../Api/CaseTransferApi";

function HistoryPersonalDetails(props) {
  const { studentId, currentScreeningStatus } = { props };
  const [studentData, setStudentData] = useState();
  const [observationData, setObservationData] = useState();
  const [profilerReportData, setProfilerReportData] = useState();
  const location = useLocation();
  const navigate = useNavigate();
  const getTranslateText = useSelector(getTranslatedTextSelector);
  const dataRef = useRef();
  const [loader, setLoader] = useState(false);
  //const student_id = 38047;
  let language_id = localStorage.getItem("l_id");
  const { _studentID, _userId } = location.state || {};

  const scrollToData = () => {
    if (dataRef.current) {
      dataRef.current.scrollIntoView({ behavior: "smooth" });
    }
  };
  // Age Calculation //
  const birthdate = studentData ? decrypt(studentData?.dob) : "";

  // Calculate the age
  function calculateAge(birthdate) {
    const birthDate = new Date(birthdate);
    const currentDate = new Date();

    // Calculate the difference in years
    const age = currentDate.getFullYear() - birthDate.getFullYear();

    // Check if the birthdate for this year has already occurred
    if (
      currentDate.getMonth() < birthDate.getMonth() ||
      (currentDate.getMonth() === birthDate.getMonth() &&
        currentDate.getDate() < birthDate.getDate())
    ) {
      // If the birthdate hasn't occurred this year yet, subtract 1 from the age
      return age - 1;
    } else {
      return age;
    }
  }
  const age = calculateAge(birthdate);
  // Age Calcultio End //

  const getStudentProfilerHistory = async (studentId, userId, languageId) => {
    setLoader(true);
    await getScreeningProfilerHistory(studentId, userId, languageId).then(
      (response) => {
        if (response) {
          setStudentData(response?.StudentDetails[0]);
          setObservationData(response);
          setProfilerReportData(response?.ProfilerForm);
        }
      }
    );
    setLoader(false);
  };

  useEffect(() => {
    getStudentProfilerHistory(_studentID, _userId, language_id);
  }, [_studentID, _userId]);

  return (
    <>
      {loader !== true ? (
        <>
          <div className="grid grid-cols-6 bg-[#F4F4FA] py-5 lg:px-[10px] px-[0px] h-[calc(100vh_-_9vh)]">
            <div className="sm:col-span-2 col-span-6  bg-[#fff] sm:rounded-[30px] rounded-t-[30px] lg:mx-[10px] sm:mx-[10px] mx-[30px] relative z-9">
              {/* Header */}
              <div className="pd-profile p-5 rounded-t-[30px]">
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                  }}
                >
                  <img
                    src={backBtn}
                    alt="Back Button"
                    onClick={() => navigate(-1)}
                    className="cursor-pointer"
                  />
                </div>
                {studentData && (
                  <div className="flex flex-col item-center justify-center py-7">
                    <div className="border-[#FD1E0E] border-[3px] rounded-[100%] w-[80px] m-auto">
                      <img
                        src={
                          studentData.studentPhotoUrl &&
                          studentData.studentPhotoUrl?.toLowerCase() !== "na" &&
                          studentData.studentPhotoUrl !== "undefined"
                            ? studentData.studentPhotoUrl
                            : "../Images/icon-student-thumbnail.png"
                        }
                        alt="Profile Pic"
                        className="w-[80px] h-[80px] border-[#fff] border-[2px] rounded-[100%] m-auto"
                      />
                    </div>

                    <h4 className="text-[#fff] text-[20px] font-medium">
                      {studentData?.studentName}
                    </h4>
                    <p className="text-[#fff] ">{studentData?.grade}</p>
                  </div>
                )}
              </div>
              {/*  */}
              <div>
                <div className="flex flex-col justify-between items-start lg:px-3 xl:px-8 sm:px-2 px-[30px] sm:py-5 pt-5 relative z-10">
                  {studentData?.activeScreeningCategoryID === 1 ? (
                    <div className="flex flex-row justify-between w-full items-center">
                      <div className="flex flex-row items-center">
                        {studentData?.currentScreeningStatus === "Done" ? (
                          <img
                            src={tickIcon}
                            alt="tick icon"
                            className="w-[20px] h-[20px] lg:w-[30px] lg:h-[30px]"
                          />
                        ) : (
                          <img
                            src={pendingIcon}
                            alt="tick icon"
                            className="w-[20px] h-[20px] lg:w-[30px] lg:h-[30px]"
                          />
                        )}

                        <div className="flex flex-col items-start ml-2">
                          <p className="lg:text-[14px] text-[12px] ">
                            {getTranslateText?.data.length > 0
                              ? getTranslateText?.data?.filter(
                                  (item) => item.pageKey === "label_screening_1"
                                )[0]?.keyValue
                                ? getTranslateText?.data?.filter(
                                    (item) =>
                                      item.pageKey === "label_screening_1"
                                  )[0]?.keyValue
                                : "Screening 1"
                              : "Screening 1"}
                          </p>
                          <span
                            className={`lg:text-[14px] text-[12px]  font-medium ${
                              studentData?.currentScreeningStatus === "Done"
                                ? "text-[#02b10f]"
                                : "text-[#FDA601]"
                            }`}
                          >
                            {studentData?.currentScreeningStatus === "Done" ? (
                              <>
                                {getTranslateText?.data.length > 0
                                  ? getTranslateText?.data?.filter(
                                      (item) => item.pageKey === "label_done"
                                    )[0]?.keyValue
                                    ? getTranslateText?.data?.filter(
                                        (item) => item.pageKey === "label_done"
                                      )[0]?.keyValue
                                    : "Done"
                                  : "Done"}
                              </>
                            ) : (
                              <>
                                {getTranslateText?.data.length > 0
                                  ? getTranslateText?.data?.filter(
                                      (item) => item.pageKey === "label_pending"
                                    )[0]?.keyValue
                                    ? getTranslateText?.data?.filter(
                                        (item) =>
                                          item.pageKey === "label_pending"
                                      )[0]?.keyValue
                                    : "Pending"
                                  : "Pending"}
                              </>
                            )}
                          </span>
                        </div>
                      </div>
                    </div>
                  ) : studentData?.activeScreeningCategoryID === 2 ? (
                    <>
                      <div className="flex flex-row justify-between w-full items-center">
                        <div className="flex flex-row items-start">
                          <div className="after:border-[#dee3f2] after:border-r-2 after:rotate-90 after:border-dotted after:h-[20px] after:w-[15px] after:pb-[5px] mt-[5px]">
                            <img
                              src={tickIcon}
                              alt="tick icon"
                              className="w-[20px] h-[20px] lg:w-[30px] lg:h-[30px]"
                            />
                          </div>

                          <div className="flex flex-col items-start ml-2">
                            <p className="lg:text-[14px] text-[12px] ">
                              {getTranslateText?.data.length > 0
                                ? getTranslateText?.data?.filter(
                                    (item) =>
                                      item.pageKey === "label_screening_1"
                                  )[0]?.keyValue
                                  ? getTranslateText?.data?.filter(
                                      (item) =>
                                        item.pageKey === "label_screening_1"
                                    )[0]?.keyValue
                                  : "Screening 1"
                                : "Screening 1"}{" "}
                            </p>
                            <span
                              className={`lg:text-[14px] text-[12px]  font-medium ${
                                studentData?.currentScreeningStatus === "Done"
                                  ? "text-[#02b10f]"
                                  : "text-[#02b10f]"
                              }`}
                            >
                              {getTranslateText?.data.length > 0
                                ? getTranslateText?.data?.filter(
                                    (item) => item.pageKey === "label_done"
                                  )[0]?.keyValue
                                  ? getTranslateText?.data?.filter(
                                      (item) => item.pageKey === "label_done"
                                    )[0]?.keyValue
                                  : "Done"
                                : "Done"}
                            </span>
                          </div>
                        </div>
                      </div>
                      <div className="flex flex-row justify-between w-full items-center">
                        <div className="flex flex-row items-center">
                          {studentData?.currentScreeningStatus === "Done" ? (
                            <img
                              src={tickIcon}
                              alt="tick icon"
                              className="w-[20px] h-[20px] lg:w-[30px] lg:h-[30px]"
                            />
                          ) : (
                            <img
                              src={pendingIcon}
                              alt="tick icon"
                              className="w-[20px] h-[20px] lg:w-[30px] lg:h-[30px]"
                            />
                          )}

                          <div className="flex flex-col items-start ml-2">
                            <p className="lg:text-[14px] text-[12px] ">
                              {getTranslateText?.data.length > 0
                                ? getTranslateText?.data?.filter(
                                    (item) =>
                                      item.pageKey === "label_screening_2"
                                  )[0]?.keyValue
                                  ? getTranslateText?.data?.filter(
                                      (item) =>
                                        item.pageKey === "label_screening_2"
                                    )[0]?.keyValue
                                  : "Profiler Form"
                                : "Profiler Form"}{" "}
                            </p>
                            <span
                              className={`lg:text-[14px] text-[12px]  font-medium ${
                                studentData?.currentScreeningStatus === "Done"
                                  ? "text-[#02b10f]"
                                  : "text-[#FDA601]"
                              }`}
                            >
                              {studentData?.currentScreeningStatus ===
                              "Done" ? (
                                <>
                                  {getTranslateText?.data.length > 0
                                    ? getTranslateText?.data?.filter(
                                        (item) => item.pageKey === "label_done"
                                      )[0]?.keyValue
                                      ? getTranslateText?.data?.filter(
                                          (item) =>
                                            item.pageKey === "label_done"
                                        )[0]?.keyValue
                                      : "Done"
                                    : "Done"}
                                </>
                              ) : (
                                <>
                                  {getTranslateText?.data.length > 0
                                    ? getTranslateText?.data?.filter(
                                        (item) =>
                                          item.pageKey === "label_pending"
                                      )[0]?.keyValue
                                      ? getTranslateText?.data?.filter(
                                          (item) =>
                                            item.pageKey === "label_pending"
                                        )[0]?.keyValue
                                      : "Pending"
                                    : "Pending"}
                                </>
                              )}{" "}
                            </span>
                          </div>
                        </div>
                      </div>
                    </>
                  ) : (
                    <>
                      <div className="flex flex-row justify-between w-full items-center">
                        <div className="flex flex-row items-start">
                          <div className="after:border-[#dee3f2] after:border-r-2 after:rotate-90 after:border-dotted after:h-[20px] after:w-[15px] mt-[5px] after:pb-[5px]">
                            <img
                              src={tickIcon}
                              alt="tick icon"
                              className="w-[20px] h-[20px] lg:w-[30px] lg:h-[30px]"
                            />
                          </div>

                          <div className="flex flex-col items-start ml-2">
                            <p className="lg:text-[14px] text-[12px] ">
                              {getTranslateText?.data.length > 0
                                ? getTranslateText?.data?.filter(
                                    (item) =>
                                      item.pageKey === "label_screening_1"
                                  )[0]?.keyValue
                                  ? getTranslateText?.data?.filter(
                                      (item) =>
                                        item.pageKey === "label_screening_1"
                                    )[0]?.keyValue
                                  : "Screening 1"
                                : "Screening 1"}
                            </p>
                            <span
                              className={`lg:text-[14px] text-[12px]  font-medium ${
                                studentData?.currentScreeningStatus === "Done"
                                  ? "text-[#02b10f]"
                                  : "text-[#02b10f]"
                              }`}
                            >
                              {getTranslateText?.data.length > 0
                                ? getTranslateText?.data?.filter(
                                    (item) => item.pageKey === "label_done"
                                  )[0]?.keyValue
                                  ? getTranslateText?.data?.filter(
                                      (item) => item.pageKey === "label_done"
                                    )[0]?.keyValue
                                  : "Done"
                                : "Done"}
                            </span>
                          </div>
                        </div>
                      </div>
                      <div className="flex flex-row justify-between w-full items-center">
                        <div className="flex flex-row items-start">
                          <div
                            classNames="before:border-[#dee3f2] before:border-l-2 before:rotate-90 before:border-dotted before:h-[2px] before:w-[2px]"
                            className="after:border-[#dee3f2] after:border-r-2 after:rotate-90 after:border-dotted after:h-[20px] after:w-[15px] after:pb-[5px]"
                          >
                            <img
                              src={tickIcon}
                              alt="tick icon"
                              className="w-[20px] h-[20px] lg:w-[30px] lg:h-[30px]"
                            />
                          </div>

                          <div className="flex flex-col items-start ml-2 ">
                            <p className="lg:text-[14px] text-[12px] ">
                              {getTranslateText?.data.length > 0
                                ? getTranslateText?.data?.filter(
                                    (item) =>
                                      item.pageKey === "label_screening_2"
                                  )[0]?.keyValue
                                  ? getTranslateText?.data?.filter(
                                      (item) =>
                                        item.pageKey === "label_screening_2"
                                    )[0]?.keyValue
                                  : "Profiler Form"
                                : "Profiler Form"}
                            </p>
                            <span
                              className={`lg:text-[14px] text-[12px]  font-medium ${
                                studentData?.currentScreeningStatus === "Done"
                                  ? "text-[#02b10f]"
                                  : "text-[#02b10f]"
                              }`}
                            >
                              {getTranslateText?.data.length > 0
                                ? getTranslateText?.data?.filter(
                                    (item) => item.pageKey === "label_done"
                                  )[0]?.keyValue
                                  ? getTranslateText?.data?.filter(
                                      (item) => item.pageKey === "label_done"
                                    )[0]?.keyValue
                                  : "Done"
                                : "Done"}
                            </span>
                          </div>
                        </div>
                      </div>
                      <div className="flex flex-row justify-between w-full items-center">
                        <div className="flex flex-row items-center">
                          {studentData?.currentScreeningStatus === "Done" ? (
                            <img
                              src={tickIcon}
                              alt="tick icon"
                              className="w-[20px] h-[20px] lg:w-[30px] lg:h-[30px]"
                            />
                          ) : (
                            <img
                              src={pendingIcon}
                              alt="tick icon"
                              className="w-[20px] h-[20px] lg:w-[30px] lg:h-[30px]"
                            />
                          )}

                          <div className="flex flex-col items-start ml-2">
                            <p className="lg:text-[14px] text-[12px] ">
                              {getTranslateText?.data.length > 0
                                ? getTranslateText?.data?.filter(
                                    (item) =>
                                      item.pageKey === "key_advance_screening"
                                  )[0]?.keyValue
                                  ? getTranslateText?.data?.filter(
                                      (item) =>
                                        item.pageKey === "key_advance_screening"
                                    )[0]?.keyValue
                                  : "Advance Screening"
                                : "Advance Screening"}
                            </p>
                            <span
                              className={`lg:text-[14px] text-[12px]  font-medium ${
                                studentData?.currentScreeningStatus === "Done"
                                  ? "text-[#02b10f]"
                                  : "text-[#FDA601]"
                              }`}
                            >
                              {studentData?.currentScreeningStatus ===
                              "Done" ? (
                                <>
                                  {getTranslateText?.data.length > 0
                                    ? getTranslateText?.data?.filter(
                                        (item) => item.pageKey === "label_done"
                                      )[0]?.keyValue
                                      ? getTranslateText?.data?.filter(
                                          (item) =>
                                            item.pageKey === "label_done"
                                        )[0]?.keyValue
                                      : "Done"
                                    : "Done"}
                                </>
                              ) : (
                                <>
                                  {getTranslateText?.data.length > 0
                                    ? getTranslateText?.data?.filter(
                                        (item) =>
                                          item.pageKey === "label_pending"
                                      )[0]?.keyValue
                                      ? getTranslateText?.data?.filter(
                                          (item) =>
                                            item.pageKey === "label_pending"
                                        )[0]?.keyValue
                                      : "Pending"
                                    : "Pending"}
                                </>
                              )}{" "}
                            </span>
                          </div>
                        </div>
                      </div>
                    </>
                  )}
                </div>
              </div>
              <img
                src={puzzleBg}
                alt="Puzzle Background"
                className="absolute bottom-0 hidden sm:block"
              />
            </div>
            {/*Student Details*/}
            <div className="sm:col-span-4 col-span-6  lg:mx-[10px] sm:mx-[10px] mx-[30px] overflow-y-scroll no-scrollbar ">
              <div className="bg-[#fff] sm:rounded-[30px] rounded-b-[30px]">
                <div className="border-b-[1px] border-[#1d2d7724] py-[15px] px-[20px]">
                  <h3 className="text-left font-semibold text-[#101942] text-[22px]">
                    {getTranslateText?.data.length > 0
                      ? getTranslateText?.data?.filter(
                          (item) => item.pageKey === "txt_personal_details"
                        )[0]?.keyValue
                        ? getTranslateText?.data?.filter(
                            (item) => item.pageKey === "txt_personal_details"
                          )[0]?.keyValue
                        : "Personal Details"
                      : "Personal Details"}
                  </h3>
                </div>
                <div className="p-5">
                  {studentData && (
                    <table className="w-full studentDetails-Table">
                      <tr>
                        <td>
                          {getTranslateText?.data.length > 0
                            ? getTranslateText?.data?.filter(
                                (item) => item.pageKey === "field_age"
                              )[0]?.keyValue
                              ? getTranslateText?.data?.filter(
                                  (item) => item.pageKey === "field_age"
                                )[0]?.keyValue
                              : "Age"
                            : "Age"}
                        </td>
                        <td>{age}</td>
                      </tr>
                      <tr>
                        <td>
                          {getTranslateText?.data.length > 0
                            ? getTranslateText?.data?.filter(
                                (item) => item.pageKey === "field_gender"
                              )[0]?.keyValue
                              ? getTranslateText?.data?.filter(
                                  (item) => item.pageKey === "field_gender"
                                )[0]?.keyValue
                              : "Gender"
                            : "Gender"}
                        </td>
                        <td>{studentData?.gender}</td>
                      </tr>
                      <tr>
                        <td>
                          {getTranslateText?.data.length > 0
                            ? getTranslateText?.data?.filter(
                                (item) => item.pageKey === "label_fathers"
                              )[0]?.keyValue
                              ? getTranslateText?.data?.filter(
                                  (item) => item.pageKey === "label_fathers"
                                )[0]?.keyValue
                              : "Father's name"
                            : "Father's name"}
                        </td>
                        <td>{studentData?.studentFatherName}</td>
                      </tr>
                      <tr>
                        <td>
                          {getTranslateText?.data.length > 0
                            ? getTranslateText?.data?.filter(
                                (item) => item.pageKey === "label_father_prof"
                              )[0]?.keyValue
                              ? getTranslateText?.data?.filter(
                                  (item) => item.pageKey === "label_father_prof"
                                )[0]?.keyValue
                              : "Father's profession"
                            : "Father's profession"}
                        </td>
                        <td>{studentData?.fatherProfessionName}</td>
                      </tr>
                      <tr>
                        <td>
                          {getTranslateText?.data.length > 0
                            ? getTranslateText?.data?.filter(
                                (item) => item.pageKey === "key_mother_name"
                              )[0]?.keyValue
                              ? getTranslateText?.data?.filter(
                                  (item) => item.pageKey === "key_mother_name"
                                )[0]?.keyValue
                              : "Mother's name"
                            : "Mother's name"}
                        </td>
                        <td>{studentData?.studentMotherName}</td>
                      </tr>
                      <tr>
                        <td>
                          {getTranslateText?.data.length > 0
                            ? getTranslateText?.data?.filter(
                                (item) => item.pageKey === "key_mother_prof"
                              )[0]?.keyValue
                              ? getTranslateText?.data?.filter(
                                  (item) => item.pageKey === "key_mother_prof"
                                )[0]?.keyValue
                              : "Mother's profession"
                            : "Mother's profession"}
                        </td>
                        <td>{studentData?.motherProfessionName}</td>
                      </tr>
                      <tr>
                        <td>
                          {getTranslateText?.data.length > 0
                            ? getTranslateText?.data?.filter(
                                (item) => item.pageKey === "key_residence"
                              )[0]?.keyValue
                              ? getTranslateText?.data?.filter(
                                  (item) => item.pageKey === "key_residence"
                                )[0]?.keyValue
                              : "Residence"
                            : "Residence"}
                        </td>
                        <td>{studentData?.residence}</td>
                      </tr>
                      <tr>
                        <td>
                          {getTranslateText?.data.length > 0
                            ? getTranslateText?.data?.filter(
                                (item) => item.pageKey === "parent_mob_no"
                              )[0]?.keyValue
                              ? getTranslateText?.data?.filter(
                                  (item) => item.pageKey === "parent_mob_no"
                                )[0]?.keyValue
                              : "Parent's Phone Number"
                            : "Parent's Phone Number"}
                        </td>
                        <td>{decrypt(studentData?.parentsMobileNo)}</td>
                      </tr>
                      <tr>
                        <td>
                          {getTranslateText?.data.length > 0
                            ? getTranslateText?.data?.filter(
                                (item) => item.pageKey === "key_school_type"
                              )[0]?.keyValue
                              ? getTranslateText?.data?.filter(
                                  (item) => item.pageKey === "key_school_type"
                                )[0]?.keyValue
                              : "Type of school"
                            : "Type of school"}
                        </td>
                        <td>{studentData?.schoolTypeName}</td>
                      </tr>
                      <tr>
                        <td>
                          {getTranslateText?.data.length > 0
                            ? getTranslateText?.data?.filter(
                                (item) => item.pageKey === "key_school_board"
                              )[0]?.keyValue
                              ? getTranslateText?.data?.filter(
                                  (item) => item.pageKey === "key_school_board"
                                )[0]?.keyValue
                              : "School board"
                            : "School board"}
                        </td>
                        <td>{studentData?.schoolBoardName}</td>
                      </tr>
                      <tr>
                        <td>
                          {getTranslateText?.data.length > 0
                            ? getTranslateText?.data?.filter(
                                (item) =>
                                  item.pageKey === "key_school_ed_details"
                              )[0]?.keyValue
                              ? getTranslateText?.data?.filter(
                                  (item) =>
                                    item.pageKey === "key_school_ed_details"
                                )[0]?.keyValue
                              : "Educational Details"
                            : "Educational Details"}
                        </td>
                        <td>{studentData?.educationTypeName}</td>
                      </tr>
                    </table>
                  )}
                </div>
              </div>
              {observationData?.Screening1 ||
              observationData?.AdvanceScreening ? (
                <>
                  {/* Classroom observation */}
                  <div className="bg-[#fff] sm:rounded-[30px] rounded-b-[30px] mt-5">
                    <div className="border-b-[1px] border-[#1d2d7724] py-[15px] px-[20px]">
                      <h3 className="text-left font-semibold text-[#101942] text-[22px]">
                        {getTranslateText?.data.length > 0
                          ? getTranslateText?.data?.filter(
                              (item) =>
                                item.pageKey === "key_classroom_observation"
                            )[0].keyValue
                            ? getTranslateText?.data?.filter(
                                (item) =>
                                  item.pageKey === "key_classroom_observation"
                              )[0].keyValue
                            : "Classroom Observation"
                          : "Classroom Observation"}
                      </h3>
                    </div>
                    <div className="p-5">
                      <>
                        {/* Screening 1 */}
                        {observationData?.Screening1 ? (
                          <>
                            <div>
                              <h3 className="text-[#101942] font-medium text-[18px] text-left mb-3 text-[#101942]">
                                {/* {observationData.Screening1[0]?.screeningName} */}{" "}
                                Screening 1
                              </h3>
                              <ul className="list-disc text-left px-5 text-[14px] text-[#101942]">
                                {observationData?.Screening1.map((item) => (
                                  <>
                                    <li className="mb-2">{item.name}</li>
                                  </>
                                ))}
                              </ul>
                            </div>
                          </>
                        ) : (
                          ""
                        )}
                      </>

                      <>
                        {/* Advance Screening */}
                        {observationData?.AdvanceScreening && (
                          <>
                            <div>
                              <h3 className="text-[#101942] font-medium text-[18px] text-left mt-5 mb-3">
                                Advance Screening
                              </h3>
                              <ul className="list-disc text-left px-5 text-[14px] text-[#101942]">
                                {observationData?.AdvanceScreening.map(
                                  (item) => (
                                    <>
                                      <li className="mb-2">{item.name}</li>
                                    </>
                                  )
                                )}
                              </ul>
                            </div>
                          </>
                        )}
                      </>
                    </div>
                  </div>
                </>
              ) : (
                ""
              )}
              {/* Profiler Report */}
              {profilerReportData?.length > 0 ? (
                <>
                  <div
                    className="bg-[#fff] sm:rounded-[30px] rounded-b-[30px] mt-5"
                    ref={dataRef}
                  >
                    <div className="border-b-[1px] border-[#1d2d7724] py-[15px] px-[20px]">
                      <h3 className="text-left font-semibold text-[#101942] text-[22px]">
                        {getTranslateText?.data.length > 0
                          ? getTranslateText?.data?.filter(
                              (item) =>
                                item.pageKey === "key_strengths_abilities"
                            )[0]?.keyValue
                            ? getTranslateText?.data?.filter(
                                (item) =>
                                  item.pageKey === "key_strengths_abilities"
                              )[0]?.keyValue
                            : "Strengths and abilities"
                          : "Strengths and abilities"}
                      </h3>
                    </div>
                    <div className="p-5">
                      {profilerReportData?.map((item) => (
                        <>
                          <div>
                            <h3 className="text-[#101942] font-medium text-[18px] text-left my-3">
                              {item?.domainMasterName}
                            </h3>
                            <ul className="list-disc text-left px-5 text-[14px] text-[#101942]">
                              {item?.statements.map((item) => (
                                <>
                                  <li className="mb-2">{item.name}</li>
                                </>
                              ))}
                            </ul>
                          </div>
                        </>
                      ))}
                    </div>
                  </div>
                </>
              ) : (
                ""
              )}
            </div>
          </div>
        </>
      ) : (
        <>
          <div className="flex justify-center items-center h-[80%]">
            <Loader type="spinningBubbles" color="#2e376c" />
          </div>
        </>
      )}
    </>
  );
}

export default HistoryPersonalDetails;
